<section class="home-section">
	<div ngx-parallax class="hero-image" id="hero">
		<div class="opacity-overlay"></div>
		<div class="home-content">
			<div class="home-text container" [ngClass]="{'title-image': titleImg}">

				<h1 class="hs-line-8 no-transp font-alt mb-50 mb-xs-30" *ngIf="!titleImg">
					{{title}}
				</h1>
				<h1 class="title-image" *ngIf="titleImg">
					<img src="assets/images/title.png" alt="Bolão Pé na Cova"/>
				</h1>

				<h3 class="font-alt mb-50 mb-xs-30">
					{{subtitle}}
				</h3>

				<app-loading class="loading" *ngIf="loading" />

				<div class="local-scroll">
					<a
						*ngIf="subscriptionOpen"
						(click)="nav.goNewList()"
						class="btn btn-mod btn-border-w btn-medium btn-round"
						>Enviar Lista</a>
					<span class="d-none d-sm-inline-block">&nbsp;&nbsp;&nbsp;</span>
					<a
						(click)="nav.goRules()"
						class="btn btn-mod btn-border-w btn-medium btn-round d-sm-inline-block"
						>Regulamento</a>
				</div>

			</div>
		</div>
	</div>
</section>
